<template>
    <v-row class="white-card px-3">
        <v-col cols="12">
            <v-img class="mx-auto" width="69" contain :src="imgLogo"/>
        </v-col>
        <v-col cols="12" class="headline-heavy text-center">
            Elige tu examen
        </v-col>
        <v-col cols="12" class="subtitle-profile">
            Puedes complementar tu estudio agregando alguno de estos pack de exámenes según tu preferencia o necesidad
        </v-col>
        <v-col cols="12">
            <exams-picker
                with-packs
                list-mode
                @change="packs = $event"
                :value="packs"
                return-object
                no-discount-packs
                ref="examsPicker"
            />
        </v-col>
        <v-col cols="12" class="text-center my-5">
            <v-btn color="primary" outlined x-large depressed class="normal-btn mr-3" @click="onBack">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn color="secondary" x-large depressed class="normal-btn" @click="onContinue">
                Continuar
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import ExamsPicker from "@/components/exams/ExamsPicker";
import LoadingSpinner from "@/components/common/LoadingSpinner";

export default {
    name: "ClientPacksSelector",
    components: {LoadingSpinner, ExamsPicker},
    props: {
        currentPacks: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            packs: [],
        }
    },
    async mounted() {
        const vm = this
        vm.setDefaults()
    },
    methods: {
        setDefaults() {
            const vm = this
            if (vm.currentPacks?.length > 0) vm.packs = vm.currentPacks
        },
        onContinue() {
            const vm = this
            vm.$emit('success', vm.packs)
        },
        onBack() {
            const vm = this
            vm.$emit('back')
        }
    },
    watch: {
        currentPacks() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>

.subtitle-profile {
    font-size: 14px;
    line-height: 16px;
    color: #939BB3;
}

</style>